/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import _ from 'lodash'
import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import Button from '../button'
// import Link from '../link'
import combineClassNames from '../../helpers/combineClassNames'
import IconCross from '../../assets/icons/icon_cross.inline.svg'
import OrderSummary from '../order-sumary'
import useStyles from './side-panel-style'

const SidePanelView = (props) => {
  const {
    isOpen = false,
    onRequestClose = () => {},
    title,
    position,
    buttons = [],
    priceSummary,
    loading = false,
    ContentTopComponent,
    children,
  } = props
  const styles = useStyles()
  const scrollTopRef = useRef(0)

  const getScrollTop = () => (
    Math.abs(window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop)
  )

  const side = position === 'left' ? 'left' : 'right'

  useEffect(() => {
    if (isOpen) {
      const scrollTop = getScrollTop()
      scrollTopRef.current = scrollTop
      document.getElementsByTagName('body')[0].setAttribute('style', `top: ${scrollTop * -1}px`)
    } else {
      _.delay(
        (top) => {
          document.body.scrollTop = top // for safari
          document.documentElement.scrollTop = top // for IE/Firefox/...others
          document.getElementsByTagName('body')[0].removeAttribute('style')
        },
        10,
        scrollTopRef.current,
      )
    }
    document.body.classList[isOpen ? 'add' : 'remove']('modal-open__side-panel')
  }, [isOpen])

  const content = _.compact([
    !_.isEmpty(title) && 'header',
    !_.isEmpty(ContentTopComponent) && 'contentTop',
    'content',
    !_.isEmpty(buttons) && 'footer',
  ])
  const contentWithSeparator = _.flatMap(
    content,
    (name, idx) => {
      if (idx !== 0) {
        return ['separator', name]
      }
      return name
    },
  )

  return createPortal(
    <div
      className={combineClassNames([
        styles.container,
        isOpen && styles.containerOpen,
        _.get(styles, _.camelCase(`container_${side}`)),
        isOpen && _.get(styles, _.camelCase(`containerOpen_${side}`)),
      ])}
      data-open
      id="side-panel"
    >
      <div
        role="button"
        className={combineClassNames([
          styles.closeMenuTriggerArea,
          isOpen && styles.closeMenuTriggerAreaOpen,
        ])}
        onClick={onRequestClose}
      >
        close
      </div>
      <div
        className={combineClassNames([
          styles.panel,
          isOpen && styles.panelOpen,
          _.get(styles, _.camelCase(`panel_${side}`)),
          isOpen && _.get(styles, _.camelCase(`panelOpen_${side}`)),
          loading && styles.panelLoading,
        ])}
      >
        {
          _.map(contentWithSeparator, (name, index) => {
            const componentKey = `side-panel-content-${name}-${index}`
            switch (name) {
              case 'header':
                return (
                  <header
                    key={componentKey}
                    className={combineClassNames([
                      styles.header,
                    ])}
                  >
                    <h1
                      className={combineClassNames([
                        styles.title,
                      ])}
                    >
                      {title}
                    </h1>
                    <Button
                      className={combineClassNames([styles.closeButton])}
                      inline
                      iconInline
                      iconImage={IconCross}
                      onClick={onRequestClose}
                    />
                  </header>
                )
              case 'contentTop':
                return (
                  <div
                    key={componentKey}
                    className={combineClassNames([
                      styles.contentTop,
                    ])}
                  >
                    {ContentTopComponent}
                  </div>
                )
              case 'content':
                return (
                  <div
                    key={componentKey}
                    className={combineClassNames([
                      styles.content,
                    ])}
                  >
                    {children}
                  </div>
                )
              case 'footer':
                return (
                  <React.Fragment
                    key={componentKey}
                  >
                    {
                      priceSummary && (
                        <OrderSummary
                          summary={priceSummary}
                          className={combineClassNames([styles.orderSummary])}
                        />
                      )
                    }
                    <footer
                      className={combineClassNames([
                        styles.footer,
                      ])}
                    >
                      {
                        _.map(buttons, ({ key, ...buttonProps }, idx) => (
                          <Button
                            key={`side-panel-button-${key || idx}`}
                            {...buttonProps}
                          />
                        ))

                      }
                    </footer>
                  </React.Fragment>
                )
              case 'separator':
                return (
                  <i key={componentKey} className={styles.separator} />
                )

              default:
                return null
            }
          })
        }
      </div>
    </div>,
    document.body,
    'side-panel',
  )
}

export default SidePanelView
